import { Box, VStack } from '@chakra-ui/react';
import { ICheckResult } from '@publishing-engine/domain/models';
import Checks from './Checks';
import { Accordion } from '@morressier/alembic';
import CheckOccurrences from './CheckOccurrences';

type IProps = {
  checks: ICheckResult[];
  roundId: string;
  submissionId: string;
  submissionContextId: string;
  currentState: string;
};

export const CheckList = ({
  checks,
  roundId,
  submissionId,
  submissionContextId,
  currentState
}: IProps) => {
  const Isoccurrences = (check: ICheckResult): boolean => {
    const occ = check.result?.occurrences;
    if (!occ?.length) return false;
    return occ.some(o => !('link' in o) || Boolean(o.link?.text));
  };
  return (
    <>
      <Box width="full" paddingBottom={6}>
        <VStack spacing={4} align="stretch">
          {checks.map(check => {
            return !Isoccurrences(check) ? (
              <Checks
                check={check}
                showUrl={true}
                submissionId={submissionId}
                roundId={roundId}
                submissionContextId={submissionContextId}
                currentState={currentState}
              />
            ) : (
              <Accordion
                chakraAccordionProps={{
                  allowMultiple: true,
                  defaultIndex: [],
                  style: {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    justifyContent: 'center'
                  }
                }}
                accordionItemProps={{
                  background: 'neutralPrimaryContentInverse',
                  marginBottom: 1,
                  width: '100%'
                }}
                items={[check].map(item => {
                  return {
                    title: (
                      <Checks
                        submissionId={submissionId}
                        check={item}
                        roundId={roundId}
                        submissionContextId={submissionContextId}
                        currentState={currentState}
                      />
                    ),
                    content: (
                      <CheckOccurrences
                        submissionId={submissionId}
                        check={item}
                        submissionContextId={submissionContextId}
                        currentState={currentState}
                      />
                    )
                  };
                })}
                variant="secondary"
              />
            );
          })}
        </VStack>
      </Box>
    </>
  );
};

export default CheckList;
